function filterEvents(filter, events) {
  if(!events) return [];
  return events.filter(event => {
    return (
      matchesFilter('hitters', filter, 'hitter_id', event) &&
      matchesFilter('runners', filter, 'karkirunner_id', event) &&
      matchesFilter('upClubs', filter, 'fielding_team_id', event) &&
      matchesFilter('spClubs', filter, 'hitting_team_id', event) &&
      matchesFilter('outfielders', filter, 'play.play_player.id', event) &&
      filterMadeOutPlayers(filter.madeOutPlayers, event) &&
      filterVedottuVaara(filter, event) &&
      filterBoolean('vvo', filter, 'vvo', event) &&
      filterBoolean('was_wrong', filter, 'was_wrong', event) &&
      matchesFilter('wrong_type', filter, 'pitch.wrong_type', event, 'wrong_type') &&
      matchesFilter('bases_state', filter, 'bases_state', event) &&
      filterBoolean('marked', filter, 'marked', event) &&
      matchesFilter('hit_outcome', filter, 'hit_outcome', event) &&
      matchesFilter('outs', filter, 'outs', event) &&
      matchesFilter('hit_number', filter, 'hit_number', event) &&
      matchesFilter('hit_type', filter, 'hit_type', event) &&
      matchesFilter('outfield_formation', filter, 'outfield_formation', event) &&
      matchesFilter('play_outcome', filter, 'play.play_outcome', event) &&
      filterBoolean('lapilyonti', filter, 'lapilyonti', event) &&
      filterBoolean('tall_pitch', filter, 'pitch.tall_pitch', event, 'tall_pitch') &&
      matchesFilter('hitter_side', filter, 'hitter_side', event) &&
      matchesFilter('hit_direction', filter, 'hit_direction', event) &&
      matchesFilter('nappi_type', filter, 'nappi_type', event) &&
      filterKotari(filter.kotari, event) &&
      filterSuperi(filter.superi, event) &&
      filterBoolean('vaara_alla', filter, 'vaara_alla', event) &&
      matchesFilter('mark_type', filter, 'mark_type', event) &&
      matchesFilter('vuoropari', filter, 'game_phase.inning', event) &&
      matchesFilter('jakso', filter, 'game_phase.jakso', event) &&
      filterBoolean('lopettava_vuoro', filter, 'game_phase.lopettava', event) &&
      filterRunMeasured(filter.run_measured, event)
    );
  });
}

function filterMadeOutPlayers(madeOutPlayers, event) {
  if(!Array.isArray(madeOutPlayers) || !madeOutPlayers.length) return true;
  if(madeOutPlayers.includes('all')) return true;

  const playerIds = new Set(madeOutPlayers.map(String));
  return Array.isArray(event.made_outs) && event.made_outs.some(madeOut => {
    return Number(madeOut?.outs) > 0 && playerIds.has(String(madeOut?.player_id));
  });
}

function filterRunMeasured(run_measured, event) {
  if(!run_measured) return true; // No filter applied
  if(run_measured.includes('all')) return true;

  if(run_measured.includes('kylla')) return !!event.run?.run_id
  if(run_measured.includes('ei')) return !event.run?.run_id
  return false;
}

function filterKotari(kotari, event) {
  if(!kotari) return true; // No filter applied
  if(kotari.includes('all')) return true;

  if(kotari.includes('kylla')) return event.game_phase.jakso === 4
  if(kotari.includes('ei')) return event.game_phase.jakso !== 4
}

function filterSuperi(superi, event) {
  if(!superi) return true; // No filter applied
  if(superi.includes('all')) return true;

  if(superi.includes('kylla')) return event.game_phase.jakso === 3
  if(superi.includes('ei')) return event.game_phase.jakso !== 3
}

function filterVedottuVaara(filter, event) {
  const eventVedottuVaara = event.vvo || event.was_wrong;
  if(!filter.vedottu_vaara) return true; // No filter applied
  if(filter.vedottu_vaara.includes('all')) return true;
  if(filter.vedottu_vaara.includes('kylla') && eventVedottuVaara) return true;
  if(filter.vedottu_vaara.includes('ei') && !eventVedottuVaara) return true;
  return false;
}

function filterBoolean(filterKey, filter, eventKey, event, fallbackEventKey) {
  const filterValue = filter[filterKey];
  if (filterValue === undefined) return true; // No filter applied
  if (filterValue.includes('all')) return true;

  const eventValue = getNestedValueWithFallback(event, eventKey, fallbackEventKey); // true or false
  if(filterValue.includes('kylla') && eventValue) return true;
  if(filterValue.includes('ei') && !eventValue) return true;
  return false;
}

function matchesFilter(filterKey, filter, eventKey, event, fallbackEventKey) {
  const filterValue = filter[filterKey];
  if (!filterValue) return true; // No filter applied

  if (Array.isArray(filterValue)) {
    if (filterValue.includes("all") || !filterValue.length) return true; // Match all
    const filterSet = new Set(filterValue); // O(1) lookup
    return filterSet.has(getNestedValueWithFallback(event, eventKey, fallbackEventKey));
  }

  return filterValue === getNestedValueWithFallback(event, eventKey, fallbackEventKey); // Single value check
}

function getNestedValue(obj, key) {
  if (!obj || typeof key !== 'string') return undefined; // Handle null/undefined obj or invalid key
  return key.split('.').reduce((acc, part) => (acc && typeof acc === 'object' ? acc[part] : undefined), obj);
}

function getNestedValueWithFallback(obj, key, fallbackKey) {
  const value = getNestedValue(obj, key);
  if(value !== undefined || !fallbackKey) return value;
  return getNestedValue(obj, fallbackKey);
}


export { filterEvents };
